<script lang="ts">
    import type {PublicStatsData} from '../../types';
    import {legendMarginChartJSPlugin} from '../../utils';
    import {Doughnut} from 'svelte-chartjs';
    import {getLocalization} from 'core/svelte-context/context';
    import {getColorFromString} from 'shared/utils/color-util';
    import KpTitledSection from 'shared/layouts/KpTitledSection.svelte';
    import {
        Chart as ChartJS,
        Title,
        Tooltip,
        Legend,
        ArcElement,
        CategoryScale,
    } from 'chart.js';

    export let statsData: PublicStatsData;
    const localize = getLocalization();

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        layout: {
            padding: {
                top: 2
            }
        },
        plugins: {
            legend: {
                display: true
            },
            legendMargin: {
                margin: 10
            }
        }
    };

    function generateSearchesData(data: PublicStatsData) {
        return {
            labels: data.stats.result.searchTypesCounts.counts.map((searchType) => `${searchType.name} - ${Math.floor(searchType.value / calculateTotalSearches(data) * 100)}%`),
            datasets: [
                {
                    data: data.stats.result.searchTypesCounts.counts.map((searchType) => searchType.value),
                    backgroundColor: data.stats.result.searchTypesCounts.counts.map((searchType) => getColorFromString(searchType.name, 70)),
                    borderWidth: 0
                },
            ],
        };
    }

    function calculateTotalSearches(data: PublicStatsData): number {
        let totalSearches = 0;
        data.stats.result.searchTypesCounts.counts.forEach((searchType) => totalSearches += searchType.value);
        return totalSearches;
    }

    ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale);
</script>

<KpTitledSection title="{localize(/* @kp-localization statistiky.podilyHledani */ 'statistiky.podilyHledani')}"
                 additionalClasses="stats-searches-graph"
                 headingType="h3">

    <div class="graph-container">
        <Doughnut data="{generateSearchesData(statsData)}"
                  plugins="{[legendMarginChartJSPlugin]}"
                  {options}/>
    </div>
</KpTitledSection>

<style lang="less">
    .graph-container {
        display: flex;
        min-width: 0;
        max-height: 400px;
        height: 100%;
    }
</style>